module.exports = __webpack_public_path__ + "static/media/google_play_color.0150069c.png";